import { render } from "./Comment.vue?vue&type=template&id=111d8898&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=111d8898&scoped=true&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111d8898"]])

export default __exports__